import {Component, OnDestroy } from '@angular/core'
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
    selector: 'checkbox-renderer',
    template: `
    <input
    type="checkbox"
    [checked]="params.data?.select_item === true"
    [disabled]="params.data?.selectable !== true"
    style="margin-left:25%;"
    />
    `,
    standalone: true,
    imports: []
})

export class CheckboxRenderer implements ICellRendererAngularComp, OnDestroy {
    public params: any;
    refresh: any;

    agInit(params: any): void {
        this.params = params;
    }

    ngOnDestroy() {}
}